import React from "react"
import { ForestPathType, ForestThoughtType } from "../ForestTypes"

let LocalForestContext = React.createContext<{
  queenThought?: ForestThoughtType
  nextPaths?: ForestPathType[]
  prevPaths?: ForestPathType[]
}>({ queenThought: undefined, nextPaths: [], prevPaths: [] })
export default LocalForestContext
